(() => {
  if (window.SSBFCMGift) return;
  const configNode = document.getElementById('ss-bfcm-gift-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.replace(/\/?$/, '/');
  const originalFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  let checked = false;
  let bypass = false;
  let unavailable = false;
  const api = window.SSBFCMGift = {mutating: false, reconcile, decline};
  const declined = () => { try { return sessionStorage.getItem('ss-bfcm-gift-declined') === '1'; } catch { return false; } };
  function decline() { try { sessionStorage.setItem('ss-bfcm-gift-declined', '1'); } catch {} }
  function resetDecline() { try { sessionStorage.removeItem('ss-bfcm-gift-declined'); } catch {} }
  async function readState() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'ss-bfcm-gift-state');
    url.searchParams.set('_ss_gift', Date.now());
    const response = await originalFetch(url, {cache: 'no-store'});
    if (!response.ok) throw new Error(config.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-ss-gift-state]');
    if (!data) throw new Error(config.error);
    return JSON.parse(data.textContent);
  }
  async function write(endpoint, body) {
    api.mutating = true;
    try {
      const response = await originalFetch(root + 'cart/' + endpoint + '.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'X-SS-Gift-Sync': '1'}, body: JSON.stringify(body)
      });
      if (!response.ok) {
        if (response.status === 422 && endpoint === 'add') { unavailable = true; return false; }
        throw new Error(config.error);
      }
      return true;
    } finally { api.mutating = false; }
  }
  async function sync() {
    const state = await readState();
    const kidsCount = state.items.reduce((n, item) => n + (item.kids ? item.quantity : 0), 0);
    const qualified = kidsCount >= (state.minimum || 2);
    if (!qualified) { resetDecline(); unavailable = false; }
    document.querySelectorAll('[data-ss-gift-offer]').forEach(el => { el.hidden = !state.active || (!state.available && !state.preview) || unavailable; });
    const gifts = state.items.filter(item => item.gift);
    const wanted = state.active && state.available && qualified && !declined() && !unavailable;
    const updates = {};
    gifts.forEach((item, index) => {
      const desired = wanted && index === 0 ? 1 : 0;
      if (item.quantity !== desired) updates[item.key] = desired;
    });
    let changed = false;
    if (Object.keys(updates).length) changed = await write('update', {updates});
    if (wanted && gifts.length === 0) changed = await write('add', {items: [{id: state.variantId, quantity: 1, properties: {_ss_gift: 'kids-two-packs'}}]});
    checked = true;
    return changed;
  }
  function reconcile() {
    const result = queue.catch(() => {}).then(sync);
    queue = result;
    return result;
  }
  function errorMessage() {
    let status = document.querySelector('[data-ss-gift-error]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.ssGiftError = '';
      status.className = 'ss-gift-error';
      status.setAttribute('role', 'alert');
      (document.querySelector('.minicart__bottom, .cart__total, main') || document.body).prepend(status);
    }
    status.textContent = config.error;
  }
  const checkout = '[name="checkout"],a[href*="/checkout"]';
  document.addEventListener('click', async event => {
    const target = event.target.closest(checkout);
    if (!target || bypass || event.button !== 0 || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try { await reconcile(); bypass = true; target.click(); } catch { errorMessage(); } finally { bypass = false; }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (bypass || !form.matches('form[action*="/cart"]') || form.action.includes('/cart/add')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try { await reconcile(); bypass = true; form.requestSubmit(event.submitter || undefined); } catch { errorMessage(); } finally { bypass = false; }
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-ss-gift-decline]')) decline();
  }, true);
  window.addEventListener('pageshow', () => {
    if (!checked) return;
    reconcile().then(changed => { if (changed) window.BoosterTheme?.cart?.dispatchListeners({change: true}); }).catch(() => {});
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' || !checked) return;
    reconcile().then(changed => { if (changed) window.BoosterTheme?.cart?.dispatchListeners({change: true}); }).catch(() => {});
  });
  reconcile().then(changed => {
    if (changed) window.BoosterTheme?.cart?.dispatchListeners({change: true});
  }).catch(() => {});
})();
